import queryString from 'query-string';

import request from 'utils/request';
import { getUserCurrentStore } from 'utils/auth';
import { pageSizeTypes } from 'utils/pagination';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

export function getReportsCancellationsRequest(
  { startDate, endDate, page, brands, voidType, reportFormat, orderBy },
  options = {},
) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const query = queryString.stringify({
    store_uuid: storeUuid,
    start_date: startDate,
    end_date: endDate,
    brand: brands,
    void_type: voidType,
    report_format: reportFormat,
    page_size: pageSizeTypes.PAGE_SIZE_DEFAULT,
    page,
    order_by: orderBy,
  });

  return request(`${API_BASE_URL}/v1/reports/void-events/?${query}`, {
    method: 'GET',
    ...options,
  });
}

export function exportReportsCancellationsExcelRequest(
  { startDate, endDate, brands, voidType, reportFormat },
  options = {},
) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const query = queryString.stringify({
    store_uuid: storeUuid,
    start_date: startDate,
    end_date: endDate,
    brand: brands,
    void_type: voidType,
    report_format: reportFormat,
  });

  return request(`${API_BASE_URL}/v1/reports/void-events/export/?${query}`, {
    method: 'GET',
    config: {
      responseType: 'blob',
    },
    ...options,
  });
}
